import SectionModal from './SectionModal';

export default SectionModal;
